module.exports = __webpack_public_path__ + "img/logo_cuseremp_dark.9b8e02ed.svg";